import Vue from 'vue'

export default {
    toggleEditMode: (state) => {
        state.isEditMode = !state.isEditMode;
    },
    setPageProperties: (state, properties) => {
        Vue.set(state, 'pageProperties', properties)
    },
    setCampaignId: (state, campaignId) => {
        state.campaignId = campaignId;
    },
    pageBuilderSelectField: (state, selected) => {
        state.pageBuilder.selectedField = selected;
    },
    setComponentStatus: (state, { component, status }) => {
        Vue.set(state.componentStatus, component, status);
    },
    setModalOptions: (state, { message = 'An error has occurred', type = 'error', isActive }) => {
        state.modal.message = message;
        state.modal.type = type;
        state.modal.isActive = isActive;
    },
    setField: (state, { field, value }) => {
        Vue.set(state, field, value)
    },
    setStep: (state, { pageStatus }) => {
        state.pageStatus = pageStatus
    },
    setReceiptToken: (state, receiptToken) => {
        state.receiptToken = receiptToken
    },
    setReceiptImage: (state, receiptImage) => {
        state.receiptImage = receiptImage
    },
    setShowNavLinks: (state, showNavLinks) => {
        state.showNavLinks = showNavLinks;
    },
    setNewCities: (state, payload) => {
        state.cities = payload;
    },
    setCustomerMobile: (state, mobile) => {
        state.customerMobile = mobile
    }
}
